import {GroupType} from "../../enums/group-type.enum";
/**
 * Created by maty on 13/02/2017.
 */

export class Permissions {
    group_id: GroupType = GroupType.Guest;
    group_name: string = "";
    read: Read = new Read();
    write: Write = new Write();
}

export class Write {
    purchase: boolean = false;
    hold: boolean = false;
    contact: boolean = false;
    memo: boolean = false;
    share: boolean = true;
    make_offer: boolean = true;
}

export class Read {
    image: boolean = true;
    lot_id: boolean = true;
    price_per_carat: boolean = true;
    price_percent: boolean = true;
    total_price: boolean = true;
    shape: boolean = true;
    carat: boolean = true;
    color: boolean = true;
    fancy: boolean = true;
    overtone: boolean = true;
    clarity: boolean = true;
    fluorescence: boolean = true;
    lab_certificate: boolean = true;
    inscription: boolean = true;
    cut: boolean = true;
    polish: boolean = true;
    symmetry: boolean = true;
    depth_percent: boolean = true;
    table_percent: boolean = true;
    measures: boolean = true;
    ratio: boolean = true;
    mounted: boolean = true;
    location: boolean = true;
    ha: boolean = true;
    vs_type: boolean = true;
    notes: boolean = true;
    cost: boolean = true;
    cost_percent: boolean = true;
    memo_price: boolean = true;
    memo_price_percent: boolean = true;
    type_ii_a: boolean = true;
    maximum_diamond_price: number = 0;
}



// WEBPACK FOOTER //
// ./src/app/entities/user/permissions.ts